import { render, staticRenderFns } from "./PageChargeBaoBillHistory.vue?vue&type=template&id=1fdac5f8"
import script from "./PageChargeBaoBillHistory.vue?vue&type=script&lang=js"
export * from "./PageChargeBaoBillHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports